import { setupWorker } from 'msw'

import { env } from '@/config/env'

export async function initMswWorker() {
  try {
    if (!env.isDev) return

    const path = './handlers'
    const { handlers } = await import(/* @vite-ignore */ path)

    const originalWorker = setupWorker(...handlers)

    originalWorker.start({
      onUnhandledRequest: 'bypass',
    })
  } catch {
    console.groupCollapsed(
      `%c[MSW] is not configured, add handlers for that.`,
      'color:orangered;font-weight:bold;',
    )
    console.groupEnd()
  }
}
